import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './PaymentResult.module.css';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={`${styles.iconCircle} ${styles.iconCancel}`}>
          <span className="material-symbols-outlined">cancel</span>
        </div>

        <h1 className={styles.title}>支付已取消</h1>
        <p className={styles.desc}>
          您已取消本次支付，没有产生任何费用。<br />
          如需开通 VIP 会员，可以随时返回重新选择。
        </p>

        <div className={styles.actions}>
          <button className={styles.primaryBtn} onClick={() => navigate('/vip/renewal')}>
            重新选择套餐
          </button>
          <button className={styles.secondaryBtn} onClick={() => navigate('/')}>
            返回首页
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;

